import React from "react";

export type TCommaList = {
    array: string[];
    preLastPhrase?: string;
    fullStop?: boolean;
    listItemClassName?: string;
};

export const CommaList = ({ array, preLastPhrase, fullStop = true, listItemClassName }: TCommaList) => {
    return (
        <>
            {array.map((string, i, array) => {
                const last = i === array.length - 1,
                    secondLast = i === array.length - 2;

                return (
                    <React.Fragment key={`${string}-${i}`}>
                        <span className={listItemClassName}>
                            {` ${string}${
                                last && fullStop ? "." : (secondLast && preLastPhrase) || (last && !fullStop) ? "" : ","
                            }`}
                        </span>
                        {secondLast && preLastPhrase && <span>{` ${preLastPhrase} `}</span>}
                    </React.Fragment>
                );
            })}
        </>
    );
};
